
import { defineComponent } from 'vue';

/**
 * Icone de Cópia.
 * @displayName IconChat [Componente do UseIcon]
 */
export default defineComponent({
    name: 'IconChat',
    props: {
        size: {
            type: [String, Number],
            default: 22,
        },
        color: {
            type: String,
            default: 'white',
        },
    },
});
